import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { get } from 'helpers/util'
import { deleteAppNotification } from 'redux/actions/app.actions'
import { Icon, CloseButton, Button, Box, Flex, Text } from '@chakra-ui/react'
import { IconDownload, IconBell } from '_base/Icon'

const Title = ({ value }) => {
  if (!value?.length) return null
  return (
    <Text fontSize="sm" fontWeight="bold">
      {value}
    </Text>
  )
}
const Body = ({ value }) => {
  if (!value?.length) return null
  return (
    <Text fontSize="xs" color="brand.muted">
      {value}
    </Text>
  )
}

const CreatedAt = ({ value }) => {
  if (!value?.length) return null
  return (
    <Text fontSize="xs" color="brand.muted">
      {moment(value).format('YYYY-MM-DD')}
    </Text>
  )
}
const DownloadUrl = ({ value }) => {
  if (!value?.length) return null
  return (
    <Box>
      <Button as="a" size="xs" mt="2" href={value} target="_blank" rel="noopener noreferrer" download>
        Download
      </Button>
    </Box>
  )
}

const icon = data => {
  const type = get([data, 'attributes', 'type'], null)
  switch (true) {
    case type?.toLowerCase() === 'download':
      return IconDownload
    default:
      return IconBell
  }
}

const AppNotificationItem = ({ data = {}, deleteAppNotification }) => {
  const uuid = get([data, 'id'], null)
  const downloadUrl = get([data, 'attributes', 'downloadUrl'], null)
  const status = get([data, 'attributes', 'status'], 'delivered')

  return (
    <Flex
      direction="column"
      align="start"
      pos="relative"
      pl="12"
      pr="8"
      py="3"
      maxW="320px"
      borderLeftWidth="4px"
      borderColor={['delivered', 'sent'].includes(status) ? 'brand.main' : 'transparent'}
      _hover={{
        bg: 'brand.hover'
      }}
    >
      <CreatedAt value={get([data, 'attributes', 'createdAt'], null)} />
      <Title value={get([data, 'attributes', 'title'], null)} />
      <Body value={get([data, 'attributes', 'body'], null)} />
      <DownloadUrl value={downloadUrl} />
      <Icon
        as={icon(data)}
        pos="absolute"
        color="brand.muted"
        left="16px"
        top="50%"
        transform="translateY(-50%)"
        fontSize="16px"
      />
      {!!uuid && (
        <CloseButton
          size="sm"
          onClick={() => {
            deleteAppNotification(uuid)
          }}
          pos="absolute"
          top="4px"
          right="8px"
        />
      )}
    </Flex>
  )
}

export default connect(null, {
  deleteAppNotification
})(AppNotificationItem)
